<template>
  <div class="review-list-bar">
    <div class="action-buttons">
      <button class="btn btn-primary create-btn" @click="openCreateModal">
        リスト新規作成
      </button>
    </div>
    <div class="search-container">
      <div class="search-box">
        <img 
          :src="require('@/assets/images/search-icon.svg')" 
          alt="検索" 
          class="search-icon"
          @error="handleImageError"
        />
        <input
          type="text"
          v-model="searchQuery"
          @keyup.enter="performSearch"
          placeholder=""
          class="search-input"
        />
      </div>
      <button class="btn search-btn" @click="performSearch">
        検索
      </button>
    </div>
    <CreateReviewList
      v-if="showCreateReviewListPopup"
      :isEditing="false"
      @hideModal="hideModal"
    />
  </div>
</template>

<script>
import CreateReviewList from './CreateReviewList.vue';
import { mapActions } from 'vuex';

export default {
  name: 'ReviewListBar',
  components: {
    CreateReviewList,
  },
  data() {
    return {
      showCreateReviewListPopup: false,
      searchQuery: '',
    };
  },
  methods: {
    ...mapActions({
      loadReviewLists: 'loadReviewLists',
    }),
    openCreateModal() {
      this.showCreateReviewListPopup = true;
    },
    hideModal() {
      this.showCreateReviewListPopup = false;
    },
    performSearch() {
      // Only search when button is clicked or Enter is pressed
      this.$emit('search', this.searchQuery);
    },
    handleImageError(e) {
      // Fallback if search icon doesn't exist
      e.target.style.display = 'none';
    },
  },
};
</script>

<style scoped lang="scss">
.review-list-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 0;
  gap: 1rem;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.create-btn {
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 400px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 0;
  padding: 0.4rem 0.8rem;
  gap: 0.5rem;
  width: 230px;
  height: 30px;
}

.search-icon {
  width: 18px;
  height: 18px;
  opacity: 0.5;
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  
  &::placeholder {
    color: #999;
  }
}

.search-btn {
  padding: 0 !important;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  background-color: #15b8a7 !important;
  color: white;
  border: none !important;
  border-radius: 0 !important;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  height: 30px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  
  &:hover {
    background-color: #129a8b !important;
  }
}
</style>
